module.exports = __webpack_public_path__ + "img/bolt-auto.21b16c2e.svg";